import React from 'react';

// Seller Component
const Seller = () => {
  const sellerData = [
    {
      srNo: 1,
      sellerId: 'Seller7638625',
      sellerName: 'MD Sahnwaj Alam',
      mobile: '8269877015',
      email: 'sarmasarma6664@gmail.com',
      entryDate: '3/25/2022 10:13:03 PM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
    {
      srNo: 2,
      sellerId: 'Seller5326699',
      sellerName: 'Neha Kushwaha',
      mobile: '8960845154',
      email: 'nehakushwaha00004@gmail.com',
      entryDate: '3/5/2022 6:35:21 PM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
    {
      srNo: 3,
      sellerId: 'Seller4507577',
      sellerName: 'Shaik IMTIYAZ',
      mobile: '7033535032',
      email: 'riya8757a@gmail.com',
      entryDate: '2/16/2022 9:46:38 AM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
    {
      srNo: 4,
      sellerId: 'Seller7190867',
      sellerName: 'Mahendra',
      mobile: '8099453009',
      email: 'sharmajisandeep19@gmail.com',
      entryDate: '10/28/2021 4:47:42 PM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
    {
      srNo: 5,
      sellerId: 'Seller203264',
      sellerName: 'Anju Mishra',
      mobile: '8738906461',
      email: 'mishraanju031@gmail.com',
      entryDate: '9/7/2021 11:51:10 AM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
    {
      srNo: 6,
      sellerId: 'Seller9415511',
      sellerName: 'Aktab Ansari',
      mobile: '8825304475',
      email: 'aktabansari79@gmail.com',
      entryDate: '8/31/2021 12:33:15 PM',
      images: {
        panImage: '',
        passbookImage: '',
        adharcardImage: '',
      },
    },
  ];

  const containerStyle = {
    marginTop: '50px',
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
    tableLayout: 'auto',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  const imgStyle = {
    width: '50px',
    height: '50px',
    objectFit: 'cover',
    borderRadius: '4px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Customer List</h2>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Seller Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Seller Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Email Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Entry Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Pan Image</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Passbook Image</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Adharcard Image</th>
          </tr>
        </thead>
        <tbody>
          {sellerData.map((seller) => (
            <tr key={seller.srNo}>
              <td style={thTdStyle}>{seller.srNo}</td>
              <td style={thTdStyle}>{seller.sellerId}</td>
              <td style={thTdStyle}>{seller.sellerName}</td>
              <td style={thTdStyle}>{seller.mobile}</td>
              <td style={thTdStyle}>{seller.email}</td>
              <td style={thTdStyle}>{seller.entryDate}</td>
              <td style={thTdStyle}>
                {seller.images.panImage ? (
                  <img src={seller.images.panImage} alt="Pan Image" style={imgStyle} />
                ) : (
                  <span>No Image</span>
                )}
              </td>
              <td style={thTdStyle}>
                {seller.images.passbookImage ? (
                  <img src={seller.images.passbookImage} alt="Passbook Image" style={imgStyle} />
                ) : (
                  <span>No Image</span>
                )}
              </td>
              <td style={thTdStyle}>
                {seller.images.adharcardImage ? (
                  <img src={seller.images.adharcardImage} alt="Adharcard Image" style={imgStyle} />
                ) : (
                  <span>No Image</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Seller;
